import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface LoadingProps {
  /** Render over existing content instead of on the page background. */
  transparent?: boolean;
}

/** Full-viewport loader used while auth state and lazy route chunks resolve. */
export default function Loading({ transparent = false }: LoadingProps) {
  return (
    <Box
      role="status"
      aria-label="Loading"
      sx={{
        position: "fixed",
        inset: 0,
        display: "grid",
        placeItems: "center",
        zIndex: (theme) => theme.zIndex.modal,
        bgcolor: transparent ? "rgba(255, 255, 255, 0.6)" : "background.default",
        backdropFilter: transparent ? "blur(2px)" : undefined,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
